/**
 * Unified Table Component
 * Consistent table layout for all management pages
 */

import React from 'react';
import './UnifiedTable.css';

const UnifiedTable = ({
    columns,
    data,
    onRowClick,
    onSelectRow,
    selectedRows = [],
    renderCell,
    className = ''
}) => {
    const handleRowClick = (row, index) => {
        if (onRowClick) {
            onRowClick(row, index);
        }
    };

    const handleSelectRow = (row, index, isSelected) => {
        if (onSelectRow) {
            onSelectRow(row.id, isSelected);
        }
    };

    const isRowSelected = (row, index) => {
        return selectedRows.includes(row.id);
    };

    return (
        <div className={`unified-table-responsive ${className}`}>
            <table className="unified-table">
                <thead>
                    <tr>
                        {onSelectRow && (
                            <th className="unified-table-select-header" scope="col">
                                <span className="sr-only">Select row</span>
                                Select
                            </th>
                        )}
                        {columns.map((column, index) => (
                            <th key={index} className={column.className || ''} scope="col">
                                {column.header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, index) => {
                        const isSelected = isRowSelected(row, index);
                        return (
                            <tr
                                key={row.id || index}
                                className={`unified-table-row ${isSelected ? 'selected' : ''}`}
                                onClick={() => handleRowClick(row, index)}
                            >
                                {onSelectRow && (
                                    <td
                                        className="unified-table-select-cell"
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={isSelected}
                                            onChange={(e) => handleSelectRow(row, index, e.target.checked)}
                                            aria-label={`Select ${row.name || row.title || row.organization_name || `Item ${index + 1}`}`}
                                            title={`Select ${row.name || row.title || row.organization_name || `Item ${index + 1}`}`}
                                        />
                                    </td>
                                )}
                                {columns.map((column, colIndex) => (
                                    <td key={colIndex} className={column.cellClassName || ''}>
                                        {renderCell ? renderCell(column, row, index) : row[column.key]}
                                    </td>
                                ))}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default UnifiedTable;
